import ApiService from './ApiService.js'

export default {
  get () {
    return ApiService.getUnhandled('exchange-rates')
  }
}
